import { Navigate, Outlet } from "react-router-dom";

import { AuthHelper } from "../helpers/auth.helper";

import { ESimulationClient } from "../types/entities.enum";

export const PrivateRoutes = () => {
    const isAuthTokenValid = AuthHelper.isAuthTokenValid().result;
    const isSessionTokenValid = AuthHelper.isSessionTokenValid().result;

    return (
        ((window.location.origin.startsWith(`https://${ESimulationClient.PROSPR}`) || window.location.origin.startsWith(`https://${ESimulationClient.RIDLEY_CONSULTING}`)) && isAuthTokenValid && isSessionTokenValid) ||
            (!window.location.origin.startsWith(`https://${ESimulationClient.PROSPR}`) && !window.location.origin.startsWith(`https://${ESimulationClient.RIDLEY_CONSULTING}`) && isSessionTokenValid)
            ? <Outlet />
            : <Navigate to="/" />
    );
};